import http from "../http-common";

class ClientsService {
  createClient(data) {
    return http.post("client/create", data);
  }
  updateClient(data) {
    return http.post("client/update", data);
  }
  getClients(data) {
    return http.get("client/list", { params: data });
  }
  deleteClient(data) {
    return http.delete("client/delete", { params: data });
  }
  getClientDetail(data) {
    return http.get("client/detail", { params: data });
  }
}

export default new ClientsService();